import {EventPropertyDefinitionsStore} from 'common/report/stores/property-definitions';
import {contextify, createRootContextHook} from 'common/util/react';

const context = contextify<EventPropertyDefinitionsStore>();

export const EventPropertyDefinitionsProvider = context.Provider;
export const EventPropertyDefinitionsConsumer = context.Consumer;
export const useEventPropertyDefinitionsLegacy = context.hook;

export const useEventPropertyDefinitions = createRootContextHook(`eventPropertyDefinitions`);
